import { useCallback, useEffect, useState } from 'react';

import { toast } from 'sonner';
import Honeybadger from '@honeybadger-io/js';

import { deserializer } from '../../../../../shared/utils/deserializer';
import { usePagination, useSearchBar } from '../../../../shared/hooks';
import { fetchReviews as apiFetchReviews } from '../services/reviewService';

const useReviewsReceived = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [reviewsReceived, setReviewsReceived] = useState([]);

  const { handlePageChange, pagination, updatePagination } = usePagination();
  const { handleSearchChange, searchInput, searchQuery } = useSearchBar();

  const fetchReviewsReceived = useCallback(async () => {
    setIsLoading(true);

    try {
      const response = await apiFetchReviews({
        clientName: searchQuery,
        page: pagination.currentPage,
        perPage: pagination.perPage,
      });

      const deserializedReviews = await deserializer.deserialize(response);

      setReviewsReceived(deserializedReviews);
      updatePagination(response.meta.pagination);
    } catch (error) {
      toast.error(error.message);
      Honeybadger.notify(error);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.perPage, searchQuery]);

  useEffect(() => {
    fetchReviewsReceived();
  }, [fetchReviewsReceived]);

  return {
    fetchReviewsReceived,
    handlePageChange,
    handleSearchChange,
    isLoading,
    pagination,
    reviewsReceived,
    searchInput,
  };
};

export default useReviewsReceived;
